import React from 'react';
import { motion } from 'framer-motion';
import { outcomes } from '../data/siteData';

function ProofStrip() {
  return (
    <section className="proof" aria-label="Why work with us">
      <div className="proof-grid">
        {outcomes.map((outcome, index) => (
          <motion.div
            className="outcome"
            key={outcome.value}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.06, duration: 0.45 }}
          >
            <strong>{outcome.value}</strong>
            <span>{outcome.label}</span>
          </motion.div>
        ))}
      </div>
    </section>
  );
}

export default ProofStrip;
